__webpack_require__.p = "/photoshop/uxp/2022/";